module.exports = __webpack_public_path__ + "static/backend-255ff1db0039ddb2c8f1cd1ae6144d77.svg";